import React from 'react';
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const CloneAttachCellRenderer = ({value}) => {
    return (
        <div className="h-full w-full flex items-center justify-center">
            <div className="font-medium pb-0 leading-normal max-w-full max-h-25 bg-[rgba(201,201,201,0.2)] rounded-lg m-2 flex items-center justify-center">
                <img className="rounded-lg max-h-18.75 max-w-[95%]" src={`${API_KEEPER}/ged/attach/${value}`} alt={value}/>
            </div>
        </div>
    );
};

export default CloneAttachCellRenderer;